
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles, Menu } from 'lucide-react';
import { DesktopAuthButtons } from '@/components/header/DesktopAuthButtons';
import { OptimizedImage } from '@/components/ui/optimized-image';
import { DesktopNav } from '@/components/header/DesktopNav';
import { MobileMenu } from '@/components/header/MobileMenu';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border">
      <div className="container mx-auto px-4 flex h-16 items-center justify-between">
        {/* Left side - Logo and app name */}
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <OptimizedImage 
              src="/lovable-uploads/1b904982-3499-4815-a723-65da0ad254ba.png" 
              alt="Retail Ranker Logo"
              width={32}
              height={32}
              className="mr-2 h-8 w-8"
              priority
            />
            <span className="font-bold text-xl">Retail Ranker</span>
          </Link>
        </div>

        {/* Center - Navigation links */}
        <DesktopNav />

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 hover:bg-accent rounded-md transition-colors z-50"
          onClick={() => setIsMenuOpen(true)}
          aria-label="Open mobile menu"
        >
          <Menu className="h-6 w-6" />
        </button>

        {/* Right side - Auth buttons (desktop only) */}
        <div className="hidden md:block">
          <DesktopAuthButtons />
        </div>

        {/* Mobile Menu */}
        <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      </div>
    </header>
  );
};

export default Header;
